<template>
  <ul>
    <li
      v-for="(item, index) in items"
      :key="keyName && `${item[keyName]}-${index}}` || index"
      :data-testid="item.value"
    >
      <slot
        name="item"
        :index="index"
        :item="item"
      />
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: [Array, Object, Set],
      required: true,
    },

    keyName: {
      type: [String, Number],
      default: 'id',
    },
  },
}
</script>
